<template>
  <div class="homepage">
    <div class="header"></div>
    <div class="body">
      <a-result status="500" title="主页内容设计中..." />
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Homepage",
  data() {
    return {};
  },
  computed: {
    ...mapState({}),
  },
  watch: {},
  mounted: function () {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
